import { Utils } from '../../../services/utils.service';

export class Cell {
    value: any;
    displayValue: string | number;
    sortingValue: string | number;
    translates: any = {};
    html: boolean = false;
    styles: any = {};
    children: any[];
    parent: boolean = false;
    hidden: boolean = false;
    active: boolean = false;
    is_new: boolean = false;
    is_column?: boolean = false;
    parent_id?: any;

    constructor(value) {
        value = (value === null || value === undefined) ? '' : value;
        this.value = value;

        if (value.parent) {
            this.parent = value.parent;
        }
        if (value.hidden) {
            this.hidden = value.hidden;
        }
        if (value.active) {
            this.active = value.active;
        }
        if (value.is_new) {
            this.is_new = value.is_new;
        }

        if (value.is_column) {
            this.is_column = value.is_column;
        }

        this.setDisplayValue();
        this.setSortingValue();

        if (typeof value == 'object' && value.styles) {
            this.styles = value.styles;
        }
    }

    setDisplayValue() {
        if (typeof this.value != 'object') {
            return this.displayValue = Cell.getPrimitive(this.value);
        }
        if (this.value.html) {
            this.html = true;
            this.displayValue = this.value.template.replace('<data>', Cell.getPrimitive(this.value.data));

            Object.keys(this.translates).forEach(key => {
                this.displayValue = (this.displayValue as string).replace(key, this.translates[key]);
            });

            return;
        }

        this.displayValue = Cell.getPrimitive(this.value.data);
    }

    setSortingValue() {
        if (typeof this.value != 'object') {
            return this.sortingValue = this.value;
        }

        this.sortingValue = this.value.data;
    }

    static getPrimitive(value) {
        if (typeof value == 'number') {
            return Utils.formatNumber(value);
        }

        return value;
    }
}
